import callHttp from "./axoisService";
import {METHOD_TYPE} from "../constants";

export const checkVaucherNumber = async (body,thunkApi) => {
    return await callHttp('voucherPortal/zoo', METHOD_TYPE.post, null, body, null,thunkApi)
};

export const getIssuesTickets  = async (voucher_no,body,thunkApi) => {
    return await callHttp(`voucherPortal/zoo/${voucher_no}/tickets`, METHOD_TYPE.post, null, body, null,thunkApi)
};

export const downloadTicket  = async (uuid_ticket,thunkApi) => {
    return await callHttp(`voucherPortal/zoo/${uuid_ticket}/tickets`, METHOD_TYPE.get, null, null, null,thunkApi,{responseType:'arraybuffer'})
};
